module.exports = __webpack_public_path__ + "media/images/woman_serving_tiny-5492c026dbbcb8aedfe551a096e75d4a.jpeg";